._title_askho_1 {
  display: flex; }

._content_askho_4 {
  max-width: 680px; }

._container_askho_7 {
  margin: 24px; }
